export const RETRY_FETCH = 'beacon/RETRY_FETCH';
